/* global angular, $, _ */
angular.module('ua5App.resource')
    .config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.when('/ucla-arts-campus-tours', 'resource/prospective-students/');
        $urlRouterProvider.when('/ucla-arts-campus-tours/', 'resource/prospective-students/');
        $urlRouterProvider.when('/ucla-arts-admissions-events', 'resource/prospective-students/');
        $urlRouterProvider.when('/ucla-arts-admissions-events/', 'resource/prospective-students/');
        $urlRouterProvider.when('/prospective-students', 'resource/prospective-students/');
        $urlRouterProvider.when('/prospective-students/', 'resource/prospective-students/');
        $urlRouterProvider.when('/arts-app', 'resource/prospective-students/');
        $urlRouterProvider.when('/arts-app/', 'resource/prospective-students/');
        $urlRouterProvider.when('/supplemental-info', 'resource/prospective-students/undergraduate-admission/');
        $urlRouterProvider.when('/supplemental-info/', 'resource/prospective-students/undergraduate-admission/');
        $urlRouterProvider.when('/departments', 'resource/academics/');
        $urlRouterProvider.when('/departments/', 'resource/academics/');
        $urlRouterProvider.when('/about-ucla-arts', 'resource/about/');
        $urlRouterProvider.when('/about-ucla-arts/', 'resource/about/');
        $urlRouterProvider.when('/student-services', 'resource/current-students/current-students-faq/');
        $urlRouterProvider.when('/student-services/', 'resource/current-students/current-students-faq/');
        $urlRouterProvider.when('/giving', function() {
            window.location.href = 'https://giving.ucla.edu/Standard/NetDonate.aspx?SiteNum=37';
        });
        $urlRouterProvider.when('/giving/', function() {
            window.location.href = 'https://giving.ucla.edu/Standard/NetDonate.aspx?SiteNum=37';
        });
        $stateProvider.state('home.resources', {
            url: 'resource/:slug/:section/',
            templateUrl: 'states/resources/resources.html',
            controller: 'ResourcesCtrl',
            controllerAs: 'ctrl',
            reloadOnSearch: false,
            params: {
                slug: {
                    value: null,
                    squash: true
                },
                section: {
                    value: null,
                    squash: true
                }
            },
            resolve: {
                data: ['Resource', '$stateParams', function(Resource, $stateParams) {
                    var slug = $stateParams.slug ? $stateParams.slug : 'about';
                    if (!$stateParams.slug) {
                        return null;
                    }
                    return Resource.data(slug).get().$promise.then(function(data) {
                        return data;
                    }, function(err) {
                        return null;
                    });
                }],
                pages: ['ResourceSections', function(ResourceSections) {
                    return ResourceSections.data().get().$promise.then(function(data) {
                        return data.sections;
                    }, function(err) {
                        return null;
                    });
                }]
            }
        });
    }])
    .controller('ResourcesCtrl', ['$rootScope', '$scope', '$sce', '$document', '$timeout', '$state', 'data', 'BREAKPOINTS', 'MetaFactory', 'pages', '$location', '$stateParams', function($rootScope, $scope, $sce, $document, $timeout, $state, data, BREAKPOINTS, MetaFactory, pages, $location, $stateParams) {

        var headerVerticalOffset;
        var windowHeight;
        var docHeight;
        var pageInfo;
        var section;

        // default to about
        if (!$state.params.slug || !data) {
            $state.go('home.resources', {slug: 'about'});
        }

        $scope.$parent.updateURL({});

        headerVerticalOffset = 110;
        windowHeight = $(window).height();
        docHeight = $(document).height();

        pageInfo = _.where(pages, {slug: $state.params.slug})[0];

        MetaFactory.set({
            title: pageInfo.title
        });

        // Sort sections by rank.
        $scope.sections = _.sortBy(data.content, 'rank');
        $scope.buttons = [];

        // Add special CTA button to resource nav on certain pages.
        if ($stateParams.slug === 'giving') {
            $scope.buttons.push({
                text: 'Make a Gift',
                url: 'https://giving.ucla.edu/Standard/NetDonate.aspx?SiteNum=37'
            });
        }

        $scope.sectionMarkers = [];
        // this is just default so that somethign is showing
        $scope.currentSection = {title: $scope.sections[0].title};

        // Scroll down to section if a section param exists in the URL.
        $scope.$on('$stateChangeSuccess', function() {
            section = $stateParams.section;
            if (section) {
                $timeout(function() {
                    $scope.scrollToSection(section);
                }, 2000);
            }
        });

        $scope.scrollToSection = function(section) {

            var isMobile,
                headerHeight,
                sectionOffset,
                widthNoScrollBars,
                globalHeaderHeight;

            // Only try if the section is on the current page.
            if ($('#scrollSection-' + section).length > 0) {
                //quickly get real viewport width (scrollbar causes error with 20px or so margin)
                $('body').css('overflow', 'hidden');
                widthNoScrollBars = $(window).width();
                $('body').css('overflow', 'auto');

                isMobile  = widthNoScrollBars <= BREAKPOINTS.MOBILE;

                $scope.toggleMobileTopNav(false);

                if (isMobile) {
                    // doing this so it's getting the right height of the header
                    var resourceNavHeight = 36;
                    globalHeaderHeight = $('.global-header-mobile').eq(0).outerHeight();
                    headerHeight = resourceNavHeight + globalHeaderHeight;
                } else {
                    globalHeaderHeight = $('.global-header').eq(0).outerHeight();
                    headerHeight = $('#resources__header-nav').outerHeight() + globalHeaderHeight;   // the scrolling header might be higher if words are stacked
                }
                sectionOffset = $('#scrollSection-' + section).offset().top - headerHeight - 20;    // 20 for padding
                $document.scrollTopAnimated(sectionOffset, 500);
                $state.go('home.resources', {
                    slug: $stateParams.slug,
                    section: section
                }, {
                    location: 'replace',
                    notify: false
                });
            }
        };

        $scope.mobileTopNavExpanded = false;
        $scope.toggleMobileTopNav = function(expanded) {
            if (expanded === false) {
                $scope.mobileTopNavExpanded = false;
            } else {
                $scope.mobileTopNavExpanded = !$scope.mobileTopNavExpanded;
            }
        };

        function broadcastState() {
            $rootScope.$broadcast('childStateLoaded', $state.current);
        }

        $timeout(function() {
            $('#resources__header-nav--single__bar-title').width($('#resources__header-nav--single').width());
            broadcastState();
            calculateActiveSection();
        });

        function recalculateSectionHeights(sectionIndex) {
            var lastTitledSection;

            docHeight = $(document).height();
            windowHeight = $(window).height();

            $scope.$apply(function() {
                // that means go through ALL the sections and recalculate heights
                for (var i = 0; i < $scope.sections.length; i++) {
                    if ($scope.sections[i].contentTypeData['cta-hideTitle'] === 'true') {
                        $scope.sectionMarkers[i] = false;
                        continue;
                    }
                    $scope.sectionMarkers[i] = $scope.sectionMarkers[i] ? $scope.sectionMarkers[i] : {};

                    if (!$scope.sectionMarkers[i] && i === sectionIndex) {

                        $scope.sectionMarkers[i].isActive = false;
                    }

                    // only recalculate if the section has been loaded
                    $scope.sectionMarkers[i].top = $('#resources__main .resources__main__section').eq(i).offset().top;
                    $scope.sectionMarkers[i].height = $('#resources__main .resources__main__section').eq(i).height();
                    $scope.sectionMarkers[i].percentTop = 100 * (($scope.sectionMarkers[i].top  - (windowHeight / 3) + headerVerticalOffset) / docHeight);
                    $scope.sectionMarkers[i].title = $scope.sections[i].title;
                    $scope.sectionMarkers[i].slug = $scope.sections[i].slug;

                    if (!$scope.sections[i].hideTitle) {
                        lastTitledSection = i;
                    }
                }

                // process last section heights to make it work for the nav
                // shave the last section so that the progress bar goes all the way
                $scope.sectionMarkers[lastTitledSection].height  = (docHeight - $scope.sectionMarkers[lastTitledSection].top) - (windowHeight / 2);

            });
        }

        function calculateActiveSection() {
            var currentScroll = $(window).scrollTop();
            var pos = currentScroll + (windowHeight / 2);
            var bool = false;   // to see if active has been set

            if (docHeight !== $(document).height()) {
                recalculateSectionHeights();
            }

            $scope.$apply(function() {
                for (var i = $scope.sections.length - 1; i >= 0; i--) {

                    if ($scope.sectionMarkers[i] && pos > $scope.sectionMarkers[i].top && !bool) {
                        $scope.sectionMarkers[i].isActive = true;
                        $scope.currentSection = $scope.sectionMarkers[i];
                        bool = true;
                        setNavSingleWidth();
                    } else if ($scope.sectionMarkers[i]) {
                        $scope.sectionMarkers[i].isActive = false;

                        // if no active, default to first section
                        if (i === 0 && bool === false) {
                            $scope.sectionMarkers[i].isActive = true;
                            $scope.currentSection = $scope.sectionMarkers[i];
                            bool = true;
                        }
                    }
                }
            });
        }

        function rewriteLinks() {
            $('#ui-state-holder').find('a[href^="/resource/' + $stateParams.slug + '/"]').not('[ui-sref]').each(function() {
                var section = $(this).attr('href').split('/').filter(Boolean)[2];
                if (section && $('#scrollSection-' + section).length > 0) {
                    $(this).data('section', section);
                    $(this).click(function(e) {
                        e.preventDefault();
                        $scope.scrollToSection($(this).data('section'));
                    });
                }

                // to show this has been processed and will be skipped next time
                $(this).attr('ui-sref', '');
            });
        }

        $scope.$on('resourceComponentPosition', function(e, args) {

            if (!args) {
                recalculateSectionHeights();
                return;
            } else if (typeof args.sectionIndex !== 'undefined' && parseInt(args.sectionIndex, 10) >= $scope.sections.length) {
                return;
            }

            recalculateSectionHeights(parseInt(args.sectionIndex, 10));
            calculateActiveSection();
            rewriteLinks();

        });

        $scope.$on('scrollToResourceSection', function(e, section) {
            $scope.scrollToSection(section);
        });

        function setNavSingleWidth() {
            var currentScroll = $(window).scrollTop();
            var pos = currentScroll + (windowHeight / 2);
            var bar = $('#resources__header-nav--single .bar').eq(0);
            var percent = 100 * (pos - $scope.currentSection.top) / $scope.currentSection.height;

            bar.css('width', percent + '%');
        }

        $scope.$on('stateRequested', broadcastState);
        $scope.$on('app:resized', function() {
            $('#resources__header-nav--single__bar-title').width($('#resources__header-nav--single').width());
            recalculateSectionHeights();
            calculateActiveSection();
            setNavSingleWidth();
        });

        $scope.$on('app:scrolled', calculateActiveSection);
        $(window).scroll(setNavSingleWidth);
    }])
;
